import Vue from 'vue'
import Router from 'vue-router'
import ProgressBar from '~/components/progress-bar.vue'
import { getLoginPath, xueshiHomePath } from '~/utils/assist'
import cookie from '~/utils/cookie'

// 全局进度条
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(Router)

const routes = [
  // 首页
  {
    path: '/',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next('/console')
      }
      location.href = xueshiHomePath
    }
  },
  {
    path: '*',
    redirect: '/'
  },
  // 控制台
  {
    path: '/console',
    component: () => import('../views/console')
  },
  // 个人中心
  {
    path: '/user',
    // 目前， 跳转到账号管理界面
    redirect: '/user/account',
    component: () => import('../views/user'),
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    },
    children: [
      {
        // 账号管理
        path: 'account',
        component: () => import('../views/user/account')
      },
      {
        // 基本信息
        path: 'record',
        component: () => import('../views/user/record')
      }
    ]
  },
  // 成果管理
  {
    path: '/achievement',
    component: () => import('../views/achievement'),
    redirect: '/achievement/my',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    },
    children: [
      {
        // 我的成果
        path: 'my',
        component: () => import('../views/achievement/my'),
        children: [
          // 记录为空
          {
            path: '',
            component: () => import('../views/achievement/my/achievement-query/achievement-empty')
          },
          // 期刊论文
          {
            path: 'qklw',
            component: () => import('../views/achievement/my/achievement-query/achievement-qklw')
          },
          // 学术活动
          {
            path: 'xshd',
            component: () => import('../views/achievement/my/achievement-query/achievement-xshd')
          },
          // 技术转让
          {
            path: 'jszr',
            component: () => import('../views/achievement/my/achievement-query/achievement-jszr')
          },
          // 成果要报
          {
            path: 'cgyb',
            component: () => import('../views/achievement/my/achievement-query/achievement-cgyb')
          },
          // 会议论文
          {
            path: 'hylw',
            component: () => import('../views/achievement/my/achievement-query/achievement-hylw')
          },
          // 研究报告
          {
            path: 'yjbg',
            component: () => import('../views/achievement/my/achievement-query/achievement-yjbg')
          },
          // 软件/系统
          {
            path: 'rjxt',
            component: () => import('../views/achievement/my/achievement-query/achievement-rjxt')
          },
          // 专著
          {
            path: 'zz',
            component: () => import('../views/achievement/my/achievement-query/achievement-zz')
          },
          // 软件著作权
          {
            path: 'rjzzq',
            component: () => import('../views/achievement/my/achievement-query/achievement-rjzzq')
          },
          // 采纳意见
          {
            path: 'cnyj',
            component: () => import('../views/achievement/my/achievement-query/achievement-cnyj')
          },
          // 领导批示
          {
            path: 'ldps',
            component: () => import('../views/achievement/my/achievement-query/achievement-ldps')
          },
          // 获奖
          {
            path: 'hj',
            component: () => import('../views/achievement/my/achievement-query/achievement-hj')
          },
          // 专利
          {
            path: 'zl',
            component: () => import('../views/achievement/my/achievement-query/achievement-zl')
          },
          // 成果登记
          {
            path: 'create',
            component: () => import('../views/achievement/my/achievement-create')
          },
          // 成果详情
          {
            path: 'detail',
            component: () => import('../views/achievement/my/achievement-detail')
          }
        ]
      },
      {
        // 成果认领
        path: 'claims',
        component: () => import('../views/achievement/claim')
      }
    ]
  },
  // 我的任务
  {
    path: '/task',
    component: () => import('../views/task'),
    redirect: '/task/my',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    },
    children: [
      {
        // 我的成果
        path: 'my',
        // component: () => import('../views/task/my.vue')
        component: () => import('../views/task/my.vue')
      },
      {
        // 成果认领
        path: 'team',
        component: () => import('../views/task/team.vue')
      }
    ]
  },
  // 学术会议
  {
    path: '/academic-meeting',
    component: () => import('../views/academic-meeting'),
    redirect: '/academic-meeting/search',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    },
    children: [
      {
        // 搜索会议
        path: 'search',
        component: () => import('../views/academic-meeting/meeting-query')
      },
      {
        // 收藏会议列表
        path: 'followlist',
        component: () => import('../views/academic-meeting/meeting-followlist')
      },
      {
        // 会议详情
        path: 'detail',
        component: () => import('../views/academic-meeting/meeting-detail')
      }
    ]
  },
  // 项目列表
  {
    path: '/project',
    component: () => import('../views/project'),
    redirect: '/project/list/managed',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    },
    children: [
      {
        path: 'list/:type',
        component: () => import('../views/project/project-list')
      }
    ]
  },
  // 项目详情 进入默认显示经费进度页面
  {
    path: '/project/detail',
    component: () => import('../views/project/project-detail'),
    redirect: '/project/detail/fund/progress',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    },
    children: [
      // ********【项目经费 start】 ********
      // 经费进度
      {
        // /project/detail/fund_progress
        path: 'fund/progress',
        component: () => import('../views/project/project-detail/fund/fund-projress/index.vue')
      },
      // 经费预算
      {
        path: 'fund/budget',
        component: () => import('../views/project/project-detail/fund/fund-budget/index.vue')
      },
      // 经费预算 -> 编辑经费
      {
        path: 'fund/budget/update',
        component: () => import('../views/project/project-detail/fund/fund-budget/update-budget.vue')
      },
      // 到账登记
      {
        // fund_progress/allotment
        path: 'fund/allotment-register',
        component: () => import('../views/project/project-detail/fund/allotment-register.vue')
      },
      // 经费明细
      {
        path: 'fund/info',
        component: () => import('../views/project/project-detail/fund/fund-detail/index.vue')
      },
      // 经费明细 -> 到账详情
      {
        path: 'fund/info/allotment',
        component: () => import('../views/project/project-detail/fund/fund-detail/allotment-info')
      },
      // 经费明细 -> 开支详情
      {
        path: 'fund/info/expense',
        component: () => import('../views/project/project-detail/fund/fund-detail/expense-info')
      },
      // 经费明细 -> 核减详情
      {
        path: 'fund/info/dec_expense',
        component: () => import('../views/project/project-detail/fund/fund-detail/dec-expense-info')
      },
      // ********【项目经费 end】***********

      // 开支登记
      {
        path: 'expense/expense-register',
        component: () => import('../views/project/project-detail/expense/expense-register.vue')
      },
      // 开支核减
      {
        path: 'expense/expense-dec',
        component: () => import('../views/project/project-detail/expense/expense-dec.vue')
      },
      // 开支审批
      {
        path: 'expense/expense-approval',
        component: () => import('../views/project/project-detail/expense/expense-approval/index.vue')
      },
      // 开支审批 -> 开支审批详情
      {
        path: 'expense/expense-approval/info',
        component: () => import('../views/project/project-detail/expense/expense-approval/approval-info/index.vue')
      },
      // 项目成果
      {
        path: 'achievement',
        component: () => import('../views/project/project-detail/project-achievement/achievement-query'),
        children: [
          // 记录为空
          {
            path: '',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-empty')
          },
          // 期刊论文
          {
            path: 'qklw',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-qklw')
          },
          // 学术活动
          {
            path: 'xshd',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-xshd')
          },
          // 技术转让
          {
            path: 'jszr',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-jszr')
          },
          // 成果要报
          {
            path: 'cgyb',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-cgyb')
          },
          // 会议论文
          {
            path: 'hylw',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-hylw')
          },
          // 研究报告
          {
            path: 'yjbg',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-yjbg')
          },
          // 软件/系统
          {
            path: 'rjxt',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-rjxt')
          },
          // 专著
          {
            path: 'zz',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-zz')
          },
          // 软件著作权
          {
            path: 'rjzzq',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-rjzzq')
          },
          // 采纳意见
          {
            path: 'cnyj',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-cnyj')
          },
          // 领导批示
          {
            path: 'ldps',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-ldps')
          },
          // 获奖
          {
            path: 'hj',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-hj')
          },
          // 专利
          {
            path: 'zl',
            component: () => import('../views/project/project-detail/project-achievement/achievement-query/achievement-zl')
          }
        ]
      },
      // 成果登记
      {
        path: 'achievement/create',
        component: () => import('../views/project/project-detail/project-achievement/achievement-create')
      },
      // 成果详情
      {
        path: 'achievement/detail',
        component: () => import('../views/project/project-detail/project-achievement/achievement-detail')
      }
    ]
  },
  // 消息列表
  {
    path: '/message',
    component: () => import('../views/user-message'),
    redirect: '/message/unread',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    },
    children: [
      {
        path: ':status',
        component: () => import('../views/user-message/list')
      }
    ]
  },
  // 团队管理
  {
    path: '/team',
    component: () => import('../views/team'),
    redirect: '/team/project',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    },
    children: [
      {
        path: 'project',
        component: () => import('../views/team/project/index.vue')
      },
      {
        path: 'info',
        component: () => import('../views/team/info/index.vue')
      },
      {
        path: 'fund',
        component: () => import('../views/team/fund/index.vue')
      },
      {
        path: 'achievement',
        component: () => import('../views/team/achievement/index.vue'),
        redirect: '/team/achievement/query',
        children: [
          {
            path: 'query',
            component: () => import('../views/team/achievement/achievement-query/index.vue')
          },
          {
            path: 'create',
            component: () => import('../views/team/achievement/achievement-create/index.vue')
          },
          {
            path: 'detail',
            component: () => import('../views/team/achievement/achievement-detail/index.vue')
          }
        ]
      },
      {
        path: 'task',
        component: () => import('../views/team/task/index.vue')
      }
    ]
  },
  // 团队管理 - 创建团队
  {
    path: '/team/create',
    component: () => import('../views/team/createTeam'),
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    }
  },
  // 团队管理 添加成员所复制的跳转链接 用来判断用户的终端类型
  {
    path: '/team/agent',
    component: () => import('../views/team/agent')
  },
  // 手机端 登录 注册 忘记密码
  {
    path: '/m',
    component: () => import('~/views/mobile/views'),
    redirect: '/m/login',
    children: [
      {
        path: 'login',
        component: () => import('~/views/mobile/views/login')
      },
      {
        path: 'register',
        component: () => import('~/views/mobile/views/register')
      },
      {
        path: 'resetPassword',
        component: () => import('~/views/mobile/views/resetPassword')
      }
    ]
  },
  // 手机端 加入团队
  {
    path: '/m/join',
    component: () => import('~/views/mobile/views/join'),
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      next({
        path: '/m/login',
        query: from.query
      })
    }
  },
  // 数据服务模块
  {
    path: '/data',
    component: () => import('~/views/data'),
    redirect: '/data/my',
    children: [
      {
        path: 'my',
        component: () => import('~/views/data/my')
      },
      {
        path: 'history',
        component: () => import('~/views/data/history')
      }
    ]
  },
  // 企业管理 创建企业
  {
    path: '/company/create',
    component: () => import('../views/company/createCompany'),
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    }
  },
  // 企业管理
  {
    path: '/company',
    component: () => import('../views/company'),
    redirect: '/company/overview',
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    },
    children: [
      {
        // 情况总览
        path: 'overview',
        component: () => import('../views/company/overview/index.vue')
      },
      {
        // 科技项目情况
        path: 'project',
        component: () => import('../views/company/project/index.vue')
      },
      {
        // 知识产权
        path: 'ipr',
        component: () => import('../views/company/ipr/index.vue')
      },
      {
        // 营收状况
        path: 'fund',
        component: () => import('../views/company/fund/index.vue')
      },
      {
        // 企业管理
        path: 'myCompany',
        component: () => import('../views/company/myCompany/index.vue')
      }
    ]
  },
  // 期刊查询
  {
    path: '/xueshi-iJournal/*',
    component: () => import('../views/iJournal'),
    beforeEnter: (to, from, next) => {
      let token = cookie.get('token')
      if (token) {
        return next()
      }
      location.href = getLoginPath()
    }
  }
]

const router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'link-active',
  scrollBehavior (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

router.beforeEach(async (to, from, next) => {
  bar.start()
  next()
})

router.afterEach((to, from) => {
  bar.finish()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js